var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "skeleton-rect",
    style: {
      width: _vm.width,
      height: _vm.height,
      borderRadius: _vm.borderRadius,
      backgroundColor: _vm.background,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }